import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import UserMainNavigatorScreen from '../screens/UserMainNavigatorScreen'
import {Route, Switch, Redirect} from 'react-router-dom'

import {actions as authActions} from '../redux/modules/Auth'
import UserAreaContainer from './UserArea/UserAreaContainer'
import CartContainer from './UserArea/Cart/CartContainer'
import ParkTicketConfiguratorContainer from './UserArea/ParkTicket/ParkTicketConfiguratorContainer'
import PaymentPageContainer from './UserArea/Checkout/PaymentPageContainer'
import PaymentResultContainer from './UserArea/Checkout/PaymentResultContainer'
import MarkRequest from './UserArea/MarkRequest'
import MarkPaymentContainer from './UserArea/Checkout/MarkPaymentContainer'
import EditMark from './UserArea/EditMark'
import AdjustmentPaymentContainer from './UserArea/Checkout/AdjustmentPaymentContainer'
import WaitingListParkTicketPayment from "./UserArea/Checkout/WaitingListParkTicketPayment";

const mapStateToProps = (state) => {
  return {
    state: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch)
  }
}

class UserMainContainer extends Component {
  onLogoutClick () {
    this.props.authActions.logout()
  }

  render () {
    return (
      <UserMainNavigatorScreen
        user={this.props.state.user}
        onLogoutClick={this.onLogoutClick.bind(this)}>
        <Switch>
          <Route path="/user-area/marks/edit/:id" component={EditMark} />
          <Route path="/user-area/marks/create" component={MarkRequest} />
          <Route path="/user-area/park-tickets/new" component={ParkTicketConfiguratorContainer} />
          <Route path="/user-area/cart" component={CartContainer} />
          <Route path="/user-area/pay/result" component={PaymentResultContainer} />
          <Route path="/user-area/pay/waitingListParkTicket/:id" component={WaitingListParkTicketPayment} />
          <Route path="/user-area/pay/mark/:id" component={MarkPaymentContainer} />
          <Route path="/user-area/pay/adjustment/:id" component={AdjustmentPaymentContainer} />
          <Route path="/user-area/pay" component={PaymentPageContainer} />
          <Route path="/user-area" component={UserAreaContainer} />

          <Redirect to="/user-area" />
        </Switch>
      </UserMainNavigatorScreen>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserMainContainer)



// WEBPACK FOOTER //
// ./src/containers/UserMainContainer.js